import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat-map";
var _context;
import React, { useState, useRef, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Manager, Popper } from 'react-popper';
import { OutsideClickDetector } from './OutsideClickDetector';
const modifiers = {
  offset: {
    offset: '4,4'
  }
};
export const availableAlignments = _flatMapInstanceProperty(_context = ['auto', 'top', 'right', 'bottom', 'left']).call(_context, align => {
  var _context2;
  return _mapInstanceProperty(_context2 = ['', '-start', '-end']).call(_context2, modificator => `${align}${modificator}`);
});
const defaultAlign = 'bottom-end';
const popoverPropTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  renderTrigger: PropTypes.func.isRequired,
  align: PropTypes.oneOf(availableAlignments),
  isFlipEnabled: PropTypes.bool
};
export const Popover = ({
  renderTrigger,
  align,
  children,
  className,
  id,
  isFlipEnabled
}) => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setShown = _useState2[1];
  const triggerRef = useRef();
  const outsideClickHandler = useCallback(({
    target
  }) => {
    const isTriggerClicked = triggerRef.current.contains(target);
    if (!isTriggerClicked) {
      setShown(false);
    }
  }, [triggerRef]);
  const close = useCallback(() => setShown(false), []);
  const toggle = useCallback(() => setShown(!isShown), [isShown]);
  const content = useMemo(() => typeof children === 'function' ? children(close) : children, [children, close]);
  if (!renderTrigger) {
    return null;
  }
  const placement = _includesInstanceProperty(availableAlignments).call(availableAlignments, align) ? align : defaultAlign;
  modifiers.flip = {
    enabled: isFlipEnabled
  };
  return React.createElement(Manager, null, renderTrigger(toggle, triggerRef, isShown), isShown && React.createElement(Popper, {
    referenceElement: triggerRef.current,
    placement: placement,
    modifiers: modifiers
  }, ({
    ref: popperRef,
    style
  }) => React.createElement(OutsideClickDetector, {
    onClickOutside: outsideClickHandler,
    onWindowBlur: close
  }, detectorRef => {
    const combinedRef = ref => {
      popperRef(ref);
      detectorRef(ref);
    };
    return React.createElement("div", {
      ref: combinedRef,
      style: style,
      className: className,
      role: "menu",
      "aria-labelledby": id
    }, content);
  })));
};
Popover.propTypes = popoverPropTypes;
Popover.defaultProps = {
  align: defaultAlign,
  isFlipEnabled: true
};
Popover.__docgenInfo = {
  componentName: "Popover",
  packageName: "@jutro/components",
  description: "Popover",
  displayName: "Popover",
  methods: [],
  actualName: "Popover",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: true,
      description: "Used to identify this component."
    },
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "CSS class name for this component"
    },
    children: {
      type: {
        name: "union",
        value: [{
          name: "node"
        }, {
          name: "func"
        }]
      },
      required: false,
      description: "Notification popover content or renderProp to render this content"
    },
    renderTrigger: {
      type: {
        name: "func"
      },
      required: true,
      description: "Function to render trigger element"
    },
    align: {
      type: {
        name: "enum",
        computed: true,
        value: "availableAlignments"
      },
      required: false,
      description: "Popover alignment (relative to trigger element)",
      defaultValue: {
        value: "'bottom-end'",
        computed: false
      }
    },
    isFlipEnabled: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Should popover flip when it is about to overflow the visible area",
      defaultValue: {
        value: "true",
        computed: false
      }
    }
  }
};